import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

import ReviewPage from "./ReviewPage";

function DigitalXrayServices() {
  return (
    <>
      <div id="x-ray-services"></div>
      <Header />
      <section className=" page p-0 m-0 gap-0">
        <div>
          {/* Header */}
          <div className="bg-light py-0 text-center">
            <h1
              className="contact-bg pt-0 text-light  text-uppercase  text-center  fw-bold col-md-12 col-lg-12 col-sm-12 "
              style={{
                fontSize: "3rem",
                letterSpacing: "3.5px",
                borderBottom: "7px solid gold",
                borderRadius: "5px",
                display: "inline-block",
                paddingBottom: "5px",
              }}
            >
              DiGITAL X-RAY
            </h1>
          </div>

          {/* Main Section / part 1*/}
          <div className="container my-5">
            <div className="row align-items-center g-4">
              {/* Left Content */}
              <div className="col-lg-6 p-0 m-0 ">
                <h2 className="fw-bold text-primary-emphasis ">
                  Get an X-ray with Comfort and Precision at Rapid Laboratory
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  X-rays – also known as radiographs – are the oldest and most
                  frequently used form of medical imaging. They are often used
                  to help diagnose fractures in bones, or infection, injury or
                  locating a foreign object in soft tissue. X-rays are also used
                  to help diagnose and monitor conditions such as pneumonia,
                  heart failure, and certain cancers. At Rapid Lab &
                  Diagnostics, we offer state-of-the-art digital X-ray services
                  that provide high-quality images with reduced radiation
                  exposure. Our experienced radiologists and technicians are
                  dedicated to ensuring your comfort and safety during the X-ray
                  process. Whether you need an X-ray for a routine check-up or
                  to investigate a specific health concern, you can trust Rapid
                  Laboratory to deliver accurate results with care and
                  precision.
                </p>

                <p className="text-primary-emphasis">
                  Our laboratory is equipped with the latest technology and
                  staffed by highly trained professionals who prioritize your
                  comfort and well-being. We understand that medical testing can
                  be stressful, which is why we have created a welcoming
                  environment to make your experience as pleasant as possible.
                </p>
              </div>
              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  src="images/assets/X-ray_woman.jpeg"
                  alt="MRI"
                  loading="lazy"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "450px",
                    objectFit: "cover",
                    width: "100%",
                  }}
                />

                {/* Thumbnails */}
                <div className="d-flex justify-content-center gap-2">
                  <img
                    loading="lazy"
                    src="images/assets/x-ray-pic.jpeg"
                    alt="lab1"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    loading="lazy"
                    src="https://images.unsplash.com/photo-1579154204601-01588f351e67"
                    alt="lab2"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                  <img
                    loading="lazy"
                    src="images/assets/rapidLab-equipment.jpeg"
                    alt="lab3"
                    className="rounded"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </div>
            </div>
            {/* put  CARD HERE */}
            <div
              className="card mb-3 mt-3 pt-md-2 shadow-sm rounded"
              style={{ maxWidth: "600px", borderTop: "4px solid #FFD700" }}
            >
              <div className="row g-0">
                <div className="col-md-12">
                  <div className="card-body">
                    <h5 className="card-title text-primary-emphasis fw-semibold">
                      How it Works
                    </h5>
                    <p className="card-text col-12">
                      Radiography is a medical imaging technique that uses
                      X-rays to view the internal structure of the body. When
                      you get an X-ray, a small amount of radiation passes
                      through your body and is absorbed by different tissues in
                      varying degrees. Dense tissues like bones absorb more
                      X-rays and appear white on the resulting image, while
                      softer tissues absorb less and appear in shades of gray.
                      The X-ray machine captures these differences to create a
                      detailed image that helps healthcare professionals
                      diagnose and monitor various conditions. At{" "}
                      <span className="text-primary-emphasis fw-bolder">
                        Rapid Lab Diagnostics
                      </span>
                      , we utilize advanced digital X-ray technology to ensure
                      high-quality images with reduced radiation exposure for
                      our patients. If you would like to know more about our
                      digital X-ray services or have any questions, please feel
                      free to contact us or visit our location for a
                      consultation.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Banner */}
            <div className="container my-5">
              <div
                className="d-flex flex-column flex-md-row align-items-center justify-content-between p-5"
                style={{
                  backgroundColor: "#0f5b7f",
                  borderRadius: "12px",
                }}
              >
                {/* Left Text */}
                <h2
                  className="text-white mb-4 mb-md-0"
                  style={{
                    fontSize: "32px",
                    fontWeight: "500",
                    maxWidth: "700px",
                    lineHeight: "1.4",
                  }}
                >
                  Visit Us for Your Laboratory Needs and Experience the
                  Difference in Care and Quality
                </h2>

                {/* Right Button */}
                <Link
                  className="link-underline link-underline-opacity-0 text-decoration-none"
                  to="https://www.google.com/maps/place/Rapid+Lab+and+Diagnostics+center/@5.6747617,-0.0208036,21z/data=!4m6!3m5!1s0xfdf813ca0f57087:0xef5fd0638781ba41!8m2!3d5.6748397!4d-0.0208213!16s%2Fg%2F11t6hmrfy0?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
                  target="_blank"
                >
                  <button
                    className="btn text-white d-flex align-items-center gap-2"
                    style={{
                      border: "2px solid white",
                      padding: "12px 24px",
                      borderRadius: "6px",
                      fontWeight: "500",
                    }}
                  >
                    LOCATION
                    <span style={{ fontSize: "18px" }}>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-caret-right-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                      </svg>
                    </span>
                  </button>
                </Link>
              </div>
            </div>
            {/* part 2 */}
            <div className="row align-items-center g-4 py-5 mt-5">
              {/* Left Content */}
              <div className="col-lg-6">
                <h2 className="fw-bold text-primary-emphasis ">
                  Reason For Digital X-Ray
                </h2>

                <div
                  className="my-3"
                  style={{
                    width: "200px",
                    height: "5px",
                    backgroundColor: "gold",
                    borderRadius: "5px",
                  }}
                ></div>

                <p className="text-primary-emphasis">
                  <ul className="p-0 m-0 ">
                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Detect fractures, infections, and abnormalities in bones
                        and soft tissues.
                      </span>
                    </li>

                    <li className="list-unstyled  pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Monitor the progression of medical conditions.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"  "}
                        Guide medical procedures like catheter or device
                        placement.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Screen for diseases such as tuberculosis or lung cancer
                        in high-risk individuals.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Assess injuries or damage after accidents or trauma.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Help diagnose conditions like arthritis, osteoporosis,
                        and certain cancers.
                      </span>
                    </li>

                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Evaluate treatment effectiveness over time.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Provide a quick, non-invasive way to obtain diagnostic
                        information.
                      </span>
                    </li>
                    <li className="list-unstyled pt-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="#ffc107"
                        className="bi bi-check-circle-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                      </svg>{" "}
                      <span className="text-primary-emphasis fs-6  ">
                        {"    "}
                        Establish baseline records for future health
                        comparisons.
                      </span>
                    </li>
                  </ul>
                </p>

                <p className="text-primary-emphasis">
                  If you have any questions about our digital X-ray services or
                  would like to schedule an appointment, please don't hesitate
                  to contact us. Our team is here to provide you with the best
                  care and support for all your diagnostic needs.
                </p>
              </div>

              {/* Right Images */}
              <div className="col-lg-6 text-center">
                <img
                  loading="lazy"
                  src="images/assets/people-in-x-ray.png"
                  alt="rapidLabEnterance"
                  className="img-fluid rounded mb-3"
                  style={{
                    maxHeight: "500px",
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            </div>
            {/* Reviews */}

            <div className="container text-center py-5 bg-muted    ">
              <ReviewPage />
              <div className="row align-items-center g-4 py-5 mt-5">
                <div className="col-lg-6 text-center">
                  <img
                    loading="lazy"
                    src="images/assets/rapidLab-equipment.jpeg"
                    alt="rapidLabEnterance"
                    className="img-fluid rounded mb-3"
                    style={{
                      maxHeight: "500px",
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </div>
                <div className="col-lg-6">
                  <h2 className="fw-bold text-primary-emphasis text-start ">
                    Choose accurate imaging and convenient service with Rapid
                    Lab Diagnostics
                  </h2>

                  <div
                    className="my-3 "
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>

                  <p className="text-primary-emphasis text-start">
                    Rapid Lab Diagnostics offers advanced X-ray services powered
                    by the latest imaging technology, ensuring precise, reliable
                    results for every patient. Our state-of-the-art equipment is
                    designed not only for accuracy but also to provide a safe,
                    efficient, and comfortable experience during every visit.
                    Our team of highly trained radiologists and skilled
                    technicians brings years of experience and a strong
                    commitment to excellence in diagnostic care. They work
                    closely together to ensure that every scan is performed with
                    attention to detail, delivering results you and your
                    healthcare provider can trust. At Rapid Lab Diagnostics,
                    patient convenience is a top priority. With our easily
                    accessible location and flexible scheduling options,
                    including timely appointments and minimal waiting times, we
                    make it simple for you to receive the diagnostic services
                    you need without unnecessary stress. We are dedicated to
                    maintaining the highest standards of care, combining
                    cutting-edge technology with compassionate service. When you
                    choose Rapid Lab Diagnostics for your X-ray needs, you’re
                    choosing accuracy, efficiency, and a patient-centered
                    approach that puts your health first.
                  </p>
                </div>
              </div>

              {/* F&Q */}
              <div>
                <p className="fs-3 text-primary-emphasis">
                  X-ray Frequently Asked Questions
                  <div
                    className="my-1 m-auto"
                    style={{
                      width: "200px",
                      height: "5px",
                      backgroundColor: "gold",
                      borderRadius: "5px",
                    }}
                  ></div>
                </p>
              </div>
              {/* Accordion */}
              <div
                className="accordion  col-10  m-auto my-5"
                id="accordionFlushExample "
                style={{ borderTop: "4px solid #FFD700", borderRadius: "8px" }}
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseOne"
                      aria-expanded="true"
                      aria-controls="flush-collapseOne"
                      style={{ borderRadius: "8px" }}
                    >
                      What happens during an X-ray?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      X-rays are fast, easy, and painless. Once the X-Ray
                      machine is carefully aimed at the part of the body being
                      examined, the x-ray machine produces a small burst of
                      radiation that passes through the body, recording an image
                      digitally. Generally, two or three X-rays will be taken
                      depending on the body part that is being viewed. You will
                      be asked to remain as still as possible during the very
                      short exposure time. If necessary, you will be instructed
                      to hold your breath to prevent motion from blurring the
                      images. X-ray exams generally take around 20 minutes,
                      after which you will be able to return to your normal
                      activities.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseTwo"
                      aria-expanded="false"
                      aria-controls="flush-collapseTwo"
                      style={{ borderRadius: "8px" }}
                    >
                      How should I prepare for an X-ray?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      We recommend that you wear comfortable, athletic-style
                      clothing. If your clothing has metal or other objects in
                      or on it (zippers, buttons, etc.), you could be asked to
                      change into a gown to eliminate the interference metal
                      objects have with the imaging technique. There is no
                      pre-exam preparation for an X-ray. Touchstone offers
                      X-rays by appointment or on a walk-in basis.
                    </div>
                  </div>
                </div>
                <div
                  className="accordion-item mt-3"
                  style={{
                    borderTop: "4px solid #FFD700",
                    borderRadius: "8px",
                  }}
                >
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#flush-collapseThree"
                      aria-expanded="false"
                      aria-controls="flush-collapseThree"
                      style={{ borderRadius: "8px" }}
                    >
                      Are X-rays safe?
                    </button>
                  </h2>
                  <div
                    id="flush-collapseThree"
                    className="accordion-collapse collapse"
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      Getting an X-ray involves exposing a part of the body to a
                      small dose of ionizing radiation to produce pictures of
                      the inside of the body. X-rays, or radiation like light or
                      radio waves, pass through most objects, including the
                      body. X-rays are safe when properly used by radiologists
                      and technologists specially trained to minimize exposure.
                      No radiation remains after the radiograph is obtained.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default DigitalXrayServices;
